import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Switch, Table, Tooltip } from "antd";
import axios from "axios";
import {
  // InfoCircleOutlined,
  PlusOutlined,
  EditOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  UserInfo,
  NotificationInfo,
  // SubscriptionInfo,
} from "../../../../context";
import MerchantCreateAddService from "./MerchantCreateAddService";
import MerchantEditAddService from "./MerchantEditAddService";

const MerchantAddtionalServices = ({
  serviceList,
  rerun,
  loading,
  setLoading,
}) => {
  // const [serviceList, setServiceList] = useState({
  //   data: [],
  //   ready: false,
  // });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  // const [productInfoDrawer, setProductInfoDrawer] = useState(false);
  const [search, setSearch] = useState("");
  // const [loading, setLoading] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [editDrawer, setEditDrawer] = useState(false);
  // const { subscriptionDetails } = useContext(SubscriptionInfo);

  const columns = [
    {
      title: "",
      dataIndex: "",
      ellipsis: true,
      render: (text) => (
        <Switch
          onChange={() => onChangeServiceStatus(parseInt(text.status), text.id)}
          checked={Boolean(parseInt(text.status))}
          size="small"
        />
      ),
    },
    {
      title: "Service",
      // dataIndex: "service",
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            display: "flex",
            // justifyContent: "center",
            alignItems: "center",
            // border: "1px solid red",
          }}
        >
          {userData.data.usersmerpermission.find(
            ({ permission }) => permission === "allow-house-keeping"
          ) &&
            text.service_type !== "one-time" && (
              <div
                style={{
                  backgroundColor:
                    text.service_status_abbreviation === "VR"
                      ? "green"
                      : text.service_status_abbreviation === "VC"
                      ? "orange"
                      : text.service_status_abbreviation === "VD"
                      ? "red"
                      : "gray",
                  width: 10,
                  height: 10,
                  borderRadius: 5,
                  marginRight: 5,
                }}
              />
            )}
          <p>{text.service}</p>
        </span>
      ),
    },
    {
      title: "Description",
      dataIndex: "service_desc",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    userData.data.usersmerpermission.find(
      ({ permission }) => permission === "allow-house-keeping"
    ) && {
      title: "Status",
      // dataIndex: "service_status_abbreviation",
      ellipsis: true,
      render: (text, record) => (
        <p style={{ textTransform: "capitalize" }}>
          {text.service_type !== "one-time" && text.service_status_abbreviation}
        </p>
      ),
    },
    {
      title: "Type",
      dataIndex: "service_type",
      ellipsis: true,
      render: (text, record) => (
        <p style={{ textTransform: "capitalize" }}>{text}</p>
      ),
    },
    {
      title: "SRP/Unit",
      // dataIndex: "srp",
      align: "center",
      render: (text, record) => (
        <p style={{ textAlign: "right" }}>
          {text.service_type === "duration"
            ? `${text.srp}/${text.service_duration}`
            : text.service_type === "one-time"
            ? `${text.srp}/person`
            : `${text.srp}`}
        </p>
      ),
    },

    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p style={{ width: 40 }}>
          {/* <Tooltip title="Product Info">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setProductInfoDrawer(true);
              }}
              icon={<InfoCircleOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip> */}

          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawer(true);
              }}
              icon={<EditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const onChangeServiceStatus = (status, id) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", id);
    formdata.append("status", parseInt(status) === 1 ? 0 : 1);
    setLoading(true);
    axios
      .post("user/merchant/update-status-additional-service", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated status successfully.");
          rerun();
          setLoading(false);
        }
      })
      .catch((error) => {
        // console.log("Error: ", error);
        setLoading(false);
      });
  };

  // const getAddtionalServiceList = useCallback(() => {
  //   var params = { user_id: userData.data.id };
  //   axios
  //     .get("user/merchant/additional-service-list", { params })
  //     .then((response) => {
  //       const data = response.data;
  //       setServiceList({ data, ready: true });
  //     })
  //     .catch((error) => {
  //       console.log("ERROR: ", error);
  //     });
  // }, [userData.data.id]);

  // useEffect(() => {
  //   getAddtionalServiceList();
  // }, [getAddtionalServiceList]);

  const searchable = serviceList.data.filter((data) => {
    return data.service.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <>
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Input
              id="search-list"
              placeholder="Search additional service"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 300,
              }}
              size="large"
            />
          </div>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setOpenDrawer(true)}
            style={{ marginRight: 5 }}
          >
            Add Additional Services
          </Button>
          <Button type="default" icon={<SyncOutlined />} onClick={rerun}>
            Refresh
          </Button>
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {/* {productInfoDrawer && (
        <MerchantProductInfo
          open={productInfoDrawer}
          close={() => setProductInfoDrawer(false)}
          selectedData={selectedData}
        />
      )} */}

      {openDrawer && (
        <MerchantCreateAddService
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getAddtionalServiceList={() => rerun()}
        />
      )}

      {editDrawer && (
        <MerchantEditAddService
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          getAddtionalServiceList={() => rerun()}
          selectedData={selectedData}
        />
      )}
    </>
  );
};

export default MerchantAddtionalServices;
